import React from 'react';
import PropTypes from 'prop-types';
import { LocalForm, Control } from 'react-redux-form';
import SelectComponent from './../Components/SelectComponent';
import {
  Col,
  ControlLabel
} from 'react-bootstrap';


const AcquisitionTelemetrySelectorComponent =
({ options, onChange, label }) => (
  <div>
    <LocalForm
      id="telemetry-search-form"
      onSubmit={onChange}
      onChange={onChange}
      initialState={{ option: '' }}
    >
      <Col md={3}>
        <ControlLabel>
          {label}
        </ControlLabel>
        <Control.custom
          id="option-input"
          model=".option"
          component={SelectComponent}
          className="form-control"
          style={{ marginRight: '10px' }}
          mapProps = {({ modelValue, onChange }) => {
            return {
              noneOption: 'Select... ',
              options: options,
              selected: modelValue,
              onChange: onChange
            };
          }
          }
        />
      </Col>
    </LocalForm>

  </div>
);

AcquisitionTelemetrySelectorComponent.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};

export default AcquisitionTelemetrySelectorComponent;


// WEBPACK FOOTER //
// src/Components/AcquisitionTelemetrySelectorComponent.jsx